import PricesPage from "./PricesPage";
export default PricesPage;
